import React from "react";
import { AudioItem } from "../components/audio-item/AudioItem";

export function Questions() {
  return (
    <div className="page">
      <AudioItem
        filePath={"./audio/questions/nangale-kaburrbun-Sn.mp3"}
        kwText={"Nangale kaburrbun?"}
        enText={"Who knows about that?"}
      />
      <AudioItem
        filePath={"./audio/questions/nangalewali-Jn.mp3"}
        kwText={"Nangalewali?"}
        enText={"Whose turn is it?"}
      />
    </div>
  );
}
